module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img4_m.4269ce81c8c80fc40092cea8d1f09ac6.jpg";